module.exports = __webpack_public_path__ + "static/img/partner5.2327c6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partner5.png
// module id = 6L9d
// module chunks = 8